import React from "react";
import { Box, Typography } from "@mui/material";
import { PageTitleProps } from "./types";

function PageTitle(props: PageTitleProps) {
  const { title, subTitle, sx, actions } = props;
  return (
    <Box
      id="page-title"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexDirection="row"
      mb={{ xs: 5, sm: 6 }}
      mt={0}
      sx={[...(Array.isArray(sx) ? sx : [sx])]}
      width={"100%"}
    >
      <Box>
        {title}
        {subTitle && (
          <Typography color="grey.70" variant="p3" display="block" mt={1}>
            {subTitle}
          </Typography>
        )}
      </Box>
      {actions}
    </Box>
  );
}

export default PageTitle;
